module.exports = __webpack_public_path__ + "img/png10.8ce37c8d.png";